/* src/app/system-utils/search-option-list/search-option-list.component.scss */
:host {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.select-label {
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
  margin-bottom: var(--tem-space-1);
}
nz-select {
  width: 100%;
}
/*# sourceMappingURL=search-option-list.component.css.map */
